import { enumBranchStyle } from "../constants";

export function GetEnumString(value) {
  for (var k in enumBranchStyle) {
    if (enumBranchStyle[k] == value) return k;
  }
}
